import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import '@trendmicro/react-sidenav/dist/react-sidenav.css'
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav'
import { Breadcrumb } from 'react-bootstrap'
import styled from 'styled-components'
import ensureArray from 'ensure-array'
// import TimeSheetMain from "../components/timesheet/TimeSheetMain";
// import TimeSheetQuery from "../components/timesheet/TimeSheetQuery";
// import TokenContainer from "../containers/TokenContainer";
import './MainPage.css'
import { PrivateRoute } from './../_components/PrivateRoute'
// import BigCalendar from './../components/calendar/BigCalendar';

import DayPickerInput from 'react-day-picker/DayPickerInput'
import 'react-day-picker/lib/style.css'

import ETimeContainers from '../containers/ETimeContainers'
import RosterContainers from '../containers/RosterContainers'
import { locale, addLocale } from 'primereact/api'

addLocale('en-NZ', {
    firstDayOfWeek: 1,
    dateFormat: 'dd/mm/yy',
    //...
})

locale('en-NZ')

// Be sure to include styles at some point, probably during your bootstraping
const Main = styled.main`
    position: absolute;
    transition: all 0.15s;
    padding: 0 20px;
    margin-left: ${props => (props.expanded ? 240 : 64)}px;
    margin-top: 60px;
`

const PleaseLogin = () => (
    <div>
        <h2>User Home Page</h2>
        <div className="jumbotron">
            <div className="container">
                <div className="col-sm-8 col-sm-offset-2">
                    <h2>You need to login to use this page! </h2>
                </div>
            </div>
        </div>
    </div>
)

const UserMain = () => (
    <div className="container">
        <div className="content-heading clearfix">
            {/* <div className="CPlogo" /> */}
            <div className="heading-left">
                <h1 className="page-title">Calendar</h1>
                <p className="page-subtitle">ETime Calendar</p>
            </div>
        </div>
        <div>
            <h2>User Home Page</h2>
            <div className="jumbotron">
                <div className="container">
                    <div className="col-sm-8 col-sm-offset-2">
                        <h2>Welcome, this is CrystalPayroll API Dashboard</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
)
class MainPage extends React.Component {
    state = {
        selected: 'home',
        expanded: false,
    }

    onSelect = selected => {}

    onToggle = expanded => {
        this.setState({ expanded: expanded })
    }

    pageTitle = {
        home: 'Home',
        time: 'TimeSheet',
        upload: 'File Upload',
        token: 'API Key',
        calendar: 'Calendar',
        roster: 'Rostering',
    }

    renderBreadcrumbs() {
        const { selected } = this.state
        const list = ensureArray(this.pageTitle[selected])

        return (
            <Breadcrumb>
                {list.map((item, index) => (
                    <Breadcrumb.Item
                        active={index === list.length - 1}
                        key={`${selected}_${index}`}
                    >
                        {item}
                    </Breadcrumb.Item>
                ))}
            </Breadcrumb>
        )
    }
    componentDidMount() {
        // this.props.dispatch(userActions.getAll());
    }

    componentWillUnmount = () => {}

    navigate = pathname => () => {
        this.setState({ selected: pathname })
    }

    // position: relative; height: calc(100vh - 50px);
    render() {
        const { expanded, selected } = this.state
        return (
            <div>
                <div
                    className="main"
                    style={{ minHeight: ' calc(100vh - 100px)' }}
                >
                    <div className="main-content">
                        <RosterContainers />
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { users, authentication } = state
    const { user } = authentication
    return {
        user,
        users,
    }
}

const connectedMainPage = connect(mapStateToProps)(MainPage)
export { connectedMainPage as MainPage }
